<template>
  <div>
    <div v-if="sheriff" class="mt-3">
      <!-- AVISO DOS SENSORES COM ERRO E WARNING -->
      <!-- AVISO DOS SENSORES COM ERRO E WARNING -->
      <div v-if="sheriff.sensors">
        <alertas/>

        <div class="container">
          <div class="d-flex flex-row-reverse px-1 pb-1">
            <a
              @click.prevent="clearStatus"
              class="btn btn-primary right"
            >{{$t("message.cleanState")}}</a>
          </div>
          <!-- SENSOR DE TEMPERATURA -->
          <!-- SENSOR DE TEMPERATURA -->
          <card :title="$tc('sensors.TemperatureSensor',2)" context="secondary">
            <div class="row">
              <temperature-sensor-view
                v-for="sensor of sensorsTemp"
                :key="sensor.id"
                :sensor="sensor"
                :unit="sheriff.configuration.temperatureUnit"
              />
            </div>
          </card>
          <!-- SENSOR DE MOVIMENTO -->
          <!-- SENSOR DE MOVIMENTO -->
          <card :title="$tc('sensors.MovementSensor', 2)" context="secondary">
            <div class="row">
              <movement-sensor-view
                v-for="sensor of sensorsMovement"
                :key="sensor.id"
                :sensor="sensor"
                :unit="sheriff.configuration.movementUnit"
              />
            </div>
          </card>
          <!-- SENSOR DE DESALINHAMENTO -->
          <!-- SENSOR DE DESALINHAMENTO -->
          <card :title="$tc('sensors.MisalignmentSensor', 2)" context="secondary">
            <ul>
              <misalignment-sensor-view
                v-for="(sensor,index) of sensorsMisalignment"
                :key="index"
                :sensor="sensor"
              />
            </ul>
          </card>
          <!-- SENSOR DE EMBUXAMENTO -->
          <!-- SENSOR DE EMBUXAMENTO -->
          <card :title="$tc('sensors.ObstructionSensor', 2)" context="secondary">
            <ul>
              <obstruction-sensor-view
                v-for="(sensor,index) of sensorsObstruction"
                :key="index"
                :sensor="sensor"
              />
            </ul>
          </card>
          <!-- POPOVER CARTAO PARA SETAR VALORES  -->
          <!-- POPOVER CARTAO PARA SETAR VALORES  -->
          <popover-set @processing="trocaEstadoCarregando"/>
        </div>
        <!-- MOSTRAR SENSORES DESABILITADOS -->
        <!-- MOSTRAR SENSORES DESABILITADOS -->
        <div id="check-sensores-desativados" class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="showCheck"
            :checked="showDisabled"
            @change="toggleDisabled()"
          >
          <label class="custom-control-label" for="showCheck">{{$t("message.showDisabledSensors")}}</label>
        </div>
      </div>
      <loader :carregando="carregando"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Card from "../resources/Card";
import { getBadge } from "../../sheriffUtils.js";
import API from "../../utils/api";
import MovementSensorView from "../sensors/MovementSensorView";
import TemperatureSensorView from "../sensors/TemperatureSensorView";
import MisalignmentSensorView from "../sensors/MisalignmentSensorView";
import ObstructionSensorView from "../sensors/ObstructionSensorView";
import PopoverSet from "../resources/PopoverSet";
import Loader from "../resources/Loader";
import Alertas from "./Alertas.vue";
let $api;

export default {
  name: "SheriffViewLista",
  created() {
    $api = new API();
  },
  data() {
    return {
      sensorSelecionado: {
        sensorConfiguration: {}
      },
      mostrarSensoresDesabilitados: false,
      carregando: false
    };
  },
  computed: {
    ...mapState(["sheriffs", "sheriff", "showDisabled"]),
    ...mapGetters([
      "sensorsTemp",
      "sensorsMisalignment",
      "sensorsObstruction",
      "sensorsMovement",
      "sensorsError",
      "sensorsTriggered"
    ])
  },
  methods: {
    getBadge,
    clearStatus() {
      this.trocaEstadoCarregando(true);
      $api
        .clearStatus(this.sheriff.id.address)
        .catch(e => {
          if (e.response.status == 401)
            this.$router.push({ path: "/login", query: { to: "/" } });
        })
        .finally(() => {
          this.trocaEstadoCarregando(false);
        });
    },
    trocaEstadoCarregando(estado) {
      this.carregando = estado;
    },
    ...mapMutations({ toggleDisabled: "toggleShowDisabled" })
  },
  directives: {
    colorState(el, binding) {
      if (binding.oldValue == binding.value) return;
      el.classList.remove(
        "state-ERROR",
        "state-OK",
        "state-TRIGGERED",
        "state-WARNING"
      );
      el.classList.add("state-" + binding.value);
      el.innerHTML = binding.value;
    }
  },
  components: {
    Card,
    MovementSensorView,
    TemperatureSensorView,
    ObstructionSensorView,
    MisalignmentSensorView,
    PopoverSet,
    Loader,
    Alertas
  }
};
</script>

<style >
#check-sensores-desativados .custom-control-label::after,
#check-sensores-desativados .custom-control-label::before {
  top: 0.05rem !important;
}
.clickable {
  cursor: pointer;
}
.state-OK {
  color: #5cb85c;
}
.state-TRIGGERED {
  color: #f0ad4e;
}
.state-ERROR {
  color: #d9534f;
}
.badge {
  font-size: 1rem;
}
.card ul {
  list-style: none;
}

@media (min-width: 470px) and (max-width: 768px) {
  .badge {
    font-size: 0.8rem;
  }
}

/* .alertas{
        position: sticky;
    top: 0;
    z-index: 1;
  } */
</style>
